var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "securitiesscenario_list"
  }, [_c("div", {
    staticClass: "securitiesscenario_list_content"
  }, [_c("section", [_c("Title", {
    staticClass: "ads_title",
    attrs: {
      title: "应用场景"
    }
  })], 1), _c("div", {
    staticClass: "securitiesscenario_list_main"
  }, [_c("div", {
    staticClass: "securitiesscenario_list_category"
  }, _vm._l(_vm.itemList, function (item) {
    return _c("div", {
      key: item.title,
      class: ["securitiesscenario_list_item", {
        securitiesscenario_list_active_title: _vm.activeIndex === item.index
      }],
      on: {
        click: function ($event) {
          _vm.activeIndex = item.index;
        }
      }
    }, [_vm.activeIndex === item.index ? _c("img", {
      attrs: {
        src: item.activeIcon,
        alt: ""
      }
    }) : _c("img", {
      attrs: {
        src: item.icon,
        alt: ""
      }
    }), _c("span", [_vm._v(_vm._s(item.title))])]);
  }), 0), _vm._l(_vm.contentList, function (item) {
    return _c("div", {
      key: item.index
    }, [item.index === _vm.activeIndex ? _c("div", {
      staticClass: "securitiesscenario_list_con"
    }, [_c("div", {
      staticClass: "securitiesscenario_list_src",
      style: {
        backgroundImage: `url(${item.bg})`
      }
    }, [_c("span", [_vm._v(_vm._s(item.desc))])])]) : _vm._e()]);
  })], 2)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };